import { keysOf } from '@/typesafe'

/**
 * Overwrite a target object a new replacement object handling removed keys
 */
export function objectReplace<A extends object, B extends object>(
  target: A,
  replacement: B,
) {
  // Clear any keys that have been removed in the replacement
  Object.keys(target).forEach((key) => {
    if (!Object.hasOwn(replacement, key)) {
      delete target[key as keyof A]
    }
  })

  Object.assign(target, replacement)

  return target as unknown as B
}

/**
 * Merge properties into a target while ignoring nullish values
 *
 * By default only undefined and null values are excluded.
 *
 * The optional third property will prevent assignment of ANY nullish value (ex. false, '', NaN, etc)
 */
export function mergeNonNullish<A extends object>(
  target: A,
  replacement: Partial<A>,
  /** If true then empty strings, boolean false, and any other value  where `!val === false` will be ignored */
  ignoreAllNullish?: boolean,
) {
  keysOf(replacement).forEach((key) => {
    if (ignoreAllNullish) {
      if (replacement[key]) {
        target[key] = replacement[key]
      }
    } else {
      if (replacement[key] !== null && replacement[key] !== undefined) {
        target[key] = replacement[key]
      }
    }
  })

  return target
}
